import script from "./Routes.vue?vue&type=script&setup=true&lang=js"
export * from "./Routes.vue?vue&type=script&setup=true&lang=js"

import "./Routes.vue?vue&type=style&index=0&id=31eb48a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31eb48a3"]])

export default __exports__